/* SUAKOVA — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var io = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mt-visible'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-mt-contar]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        var el = en.target, fin = parseFloat(el.getAttribute('data-mt-contar')) || 0, suf = el.getAttribute('data-sufijo') || '';
        if (reduce) { el.textContent = fin + suf; return; }
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var k = Math.min((t - t0) / dur, 1), v = fin * (1 - Math.pow(1 - k, 3));
          el.textContent = (fin % 1 ? v.toFixed(1) : Math.round(v)) + suf;
          if (k < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { obs.observe(e); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var piezas = document.querySelectorAll('[data-mt-parallax]');
    if (!piezas.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function mover() {
      var y = window.scrollY;
      piezas.forEach(function (p) {
        var f = parseFloat(p.getAttribute('data-mt-parallax')) || 0;
        p.style.translate = '0 ' + (y * f).toFixed(1) + 'px';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(mover); ticking = true; } }, { passive: true });
  }

  /* ---------- Aviso (toast) ---------- */
  var toastTimer;
  function aviso(texto, conEnlace) {
    var t = document.querySelector('.mt-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mt-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '<span>' + texto + '</span>' + (conEnlace ? '<a href="' + ((window.routes && window.routes.cart_url) || '/cart') + '">Ver carrito</a>' : '');
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }

  /* ---------- Añadir al carrito (usa el cajón de Dawn si existe) ---------- */
  function anadir(items, boton) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    } else {
      body.sections = ['cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    var txt = boton ? boton.innerHTML : '';
    if (boton) { boton.disabled = true; boton.setAttribute('aria-busy', 'true'); boton.innerHTML = '<span>Añadiendo…</span>'; }
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) { aviso(res.description || res.message || 'No se pudo añadir. Inténtalo de nuevo.', false); return; }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        res.id = res.id || (res.items && res.items[0] && res.items[0].id);
        drawer.renderContents(res);
      } else {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var tmp = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var nuevo = tmp.querySelector('.shopify-section');
          if (nuevo) bubble.innerHTML = nuevo.innerHTML;
        }
        aviso('¡Añadido al carrito!', true);
      }
    }).catch(function () { aviso('Algo falló de nuestro lado. Inténtalo otra vez.', false); })
      .finally(function () { if (boton) { boton.disabled = false; boton.removeAttribute('aria-busy'); boton.innerHTML = txt; } });
  }

  function initFormsRapidos(root) {
    (root || document).querySelectorAll('form[data-mt-ajax]').forEach(function (f) {
      if (f.dataset.mtListo) return; f.dataset.mtListo = '1';
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]');
        if (!id || !id.value) return;
        anadir([{ id: Number(id.value), quantity: q ? Math.max(1, parseInt(q.value, 10) || 1) : 1 }], f.querySelector('[type="submit"]'));
      });
    });
  }

  /* ---------- Kit ---------- */
  function initKits(root) {
    (root || document).querySelectorAll('[data-mt-kit]').forEach(function (k) {
      var b = k.querySelector('[data-mt-kit-boton]');
      if (!b || b.dataset.mtListo) return; b.dataset.mtListo = '1';
      b.addEventListener('click', function () {
        var ids = (k.getAttribute('data-mt-kit') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        anadir(ids.map(function (i) { return { id: Number(i), quantity: 1 }; }), b);
      });
    });
  }

  /* ---------- Tarjetas de kit (varios productos, con opción por producto) ---------- */
  function initKitCards(root) {
    (root || document).querySelectorAll('[data-mt-kitc]').forEach(function (card) {
      if (card.dataset.mtListo) return; card.dataset.mtListo = '1';
      var fmt = window.mtMoneda || null;
      var totalEl = card.querySelector('[data-mt-kitc-total]'), antesEl = card.querySelector('[data-mt-kitc-antes]');
      function dinero(c) {
        var v = (c / 100).toFixed(2), p = v.split('.'), ent = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (fmt) return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, ent).replace(/\{\{\s*amount[^}]*\}\}/, ent + '.' + p[1]);
        return '$ ' + ent + '.' + p[1];
      }
      function dato(el, attr) {
        if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; return parseInt(o.getAttribute(attr), 10) || 0; }
        return parseInt(el.getAttribute(attr), 10) || 0;
      }
      function recalcular() {
        var t = 0, a = 0;
        card.querySelectorAll('[data-mt-kitc-var]').forEach(function (el) {
          var pr = dato(el, 'data-precio'), an = dato(el, 'data-antes');
          t += pr; a += Math.max(an, pr);
          if (el.tagName === 'SELECT') { var pe = el.closest('[data-mt-kitc-item]').querySelector('.mt-kitc__precio'); if (pe) pe.textContent = dinero(pr); }
        });
        if (totalEl) totalEl.textContent = dinero(t);
        if (antesEl) { antesEl.hidden = !(a > t); antesEl.textContent = dinero(a); }
      }
      card.querySelectorAll('select[data-mt-kitc-var]').forEach(function (s) { s.addEventListener('change', recalcular); });
      var b = card.querySelector('[data-mt-kitc-boton]');
      if (b) b.addEventListener('click', function () {
        var items = [];
        card.querySelectorAll('[data-mt-kitc-var]').forEach(function (el) { if (el.value) items.push({ id: Number(el.value), quantity: 1 }); });
        if (items.length) anadir(items, b);
      });
    });
  }

  /* ---------- Pestañas de productos ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-mt-tabs]').forEach(function (s) {
      if (s.dataset.mtListo) return; s.dataset.mtListo = '1';
      var tabs = Array.prototype.slice.call(s.querySelectorAll('[data-mt-tab]'));
      function activar(t) {
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-activa', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        s.querySelectorAll('[data-mt-panel]').forEach(function (p) {
          var on = p.getAttribute('data-mt-panel') === t.getAttribute('data-mt-tab');
          p.hidden = !on;
          if (on) p.querySelectorAll('.mt-reveal').forEach(function (r) { r.classList.add('mt-visible'); });
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activar(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; n.focus(); activar(n);
        });
      });
    });
  }

  /* ---------- Ficha de producto: galería, variantes, cantidad, barra fija ---------- */
  function initFicha(root) {
    (root || document).querySelectorAll('[data-mt-ficha]').forEach(function (ficha) {
      if (ficha.dataset.mtListo) return; ficha.dataset.mtListo = '1';
      var principal = ficha.querySelector('.mt-galeria__principal');
      var img = principal ? principal.querySelector('img') : null;
      var minis = Array.prototype.slice.call(ficha.querySelectorAll('.mt-galeria__mini'));
      var actual = 0;
      function verFoto(i) {
        if (!img || !minis.length) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        principal.classList.add('mt-cambiando');
        setTimeout(function () {
          img.src = m.getAttribute('data-src'); img.srcset = m.getAttribute('data-srcset') || ''; img.alt = m.getAttribute('data-alt') || '';
          principal.classList.remove('mt-cambiando');
        }, 180);
        minis.forEach(function (x, j) { x.classList.toggle('is-activa', j === actual); x.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
        m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { verFoto(i); }); });
      var prev = ficha.querySelector('.mt-galeria__flecha--prev'), next = ficha.querySelector('.mt-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { verFoto(actual - 1); });
      if (next) next.addEventListener('click', function () { verFoto(actual + 1); });
      if (principal) {
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) verFoto(actual + (dx < 0 ? 1 : -1)); x0 = null; });
      }

      /* Variantes */
      var jsonEl = ficha.querySelector('[data-mt-variantes]');
      var variantes = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var inputId = ficha.querySelector('form [name="id"]');
      var btn = ficha.querySelector('[data-mt-boton-compra]');
      var precioEl = ficha.querySelector('[data-mt-precio]'), antesEl = ficha.querySelector('[data-mt-antes]'), ahorroEl = ficha.querySelector('[data-mt-ahorro]');
      var stockEl = ficha.querySelector('[data-mt-stock]');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]'), barraBtn = document.querySelector('[data-mt-barra-boton]');
      var formato = ficha.getAttribute('data-moneda') || '${{amount}}';
      var txtAgotado = ficha.getAttribute('data-txt-agotado') || 'Agotado';
      var txtComprar = btn ? btn.innerHTML : '';
      function dinero(c) {
        var v = (c / 100).toFixed(2), partes = v.split('.'), ent = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, ent).replace(/\{\{\s*amount[^}]*\}\}/, ent + '.' + partes[1]);
      }
      function seleccion() {
        var opts = [];
        ficha.querySelectorAll('.mt-opcion').forEach(function (fs) { var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null); });
        return opts;
      }
      function actualizar() {
        if (!variantes.length) return;
        var sel = seleccion();
        ficha.querySelectorAll('.mt-opcion').forEach(function (fs, i) {
          var leg = fs.querySelector('legend span'); if (leg) leg.textContent = sel[i] || '';
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'No disponible'; } return; }
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = dinero(v.price);
        if (barraPrecio) barraPrecio.textContent = dinero(v.price);
        var oferta = v.compare_at_price && v.compare_at_price > v.price;
        if (antesEl) { antesEl.textContent = oferta ? dinero(v.compare_at_price) : ''; antesEl.hidden = !oferta; }
        if (ahorroEl) { ahorroEl.hidden = !oferta; if (oferta) ahorroEl.textContent = 'Ahorras ' + dinero(v.compare_at_price - v.price) + ' (-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%)'; }
        var cont = ficha.querySelector('.mt-precio'); if (cont) cont.classList.toggle('mt-precio--oferta', !!oferta);
        [btn, barraBtn].forEach(function (b) { if (!b) return; b.disabled = !v.available; if (b === btn) b.innerHTML = v.available ? txtComprar : txtAgotado; });
        if (stockEl) {
          var bajo = v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
          stockEl.classList.toggle('mt-stock--bajo', !!bajo);
          var t = stockEl.querySelector('span:last-child');
          if (t) t.textContent = !v.available ? txtAgotado : (bajo ? '¡Solo quedan ' + v.inventory_quantity + '!' : (stockEl.getAttribute('data-txt-ok') || 'En stock'));
        }
        if (v.featured_media_id) {
          var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == String(v.featured_media_id); });
          if (idx > -1 && idx !== actual) verFoto(idx);
        }
        if (history.replaceState && ficha.hasAttribute('data-url-variante')) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }
      ficha.querySelectorAll('.mt-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      /* Cantidad */
      var q = ficha.querySelector('.mt-cantidad input');
      ficha.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () { if (!q) return; q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-mt-cant'), 10)); });
      });

      /* Barra fija en móvil */
      var barra = document.querySelector('.mt-barra-fija');
      var zona = ficha.querySelector('[data-mt-boton-compra]');
      if (barra && zona && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { barra.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(zona);
        if (barraBtn) barraBtn.addEventListener('click', function () { var f = zona.closest('form'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); });
      }
    });
  }

  /* ---------- Relacionados (recomendaciones de Shopify) ---------- */
  function initRelacionados(root) {
    (root || document).querySelectorAll('[data-mt-relacionados]').forEach(function (el) {
      if (el.dataset.mtListo) return; el.dataset.mtListo = '1';
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-mt-relacionados-grid]');
        var dest = el.querySelector('[data-mt-relacionados-grid]');
        if (nuevo && dest && nuevo.children.length >= dest.children.length) {
          if (dest) { dest.innerHTML = nuevo.innerHTML; el.hidden = false; initReveals(el); initFormsRapidos(el); }
        }
      }).catch(function () {});
    });
  }

  /* ---------- Orden en colección ---------- */
  function initOrden(root) {
    (root || document).querySelectorAll('[data-mt-orden]').forEach(function (s) {
      if (s.dataset.mtListo) return; s.dataset.mtListo = '1';
      s.addEventListener('change', function () {
        var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString();
      });
    });
  }

  function initTodo(root) {
    initReveals(root); initContadores(root); initFormsRapidos(root); initKits(root); initKitCards(root); initTabs(root); initFicha(root); initRelacionados(root); initOrden(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
